import EraType from "@/roc/era/EraType";
import { useLayoutStore } from "@/roc/stores/LayoutStore";
import { useWonderStore } from "@/roc/stores/WonderStore";
import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import PassiveAuraType from "@/roc/effects/PassiveAura/PassiveAuraType";
import { applyWonderSynergies } from "@/components/Bonuses/Calculator/Bonus";
class WorkersCalculator {
    static calculate(playerEra) {
        const lytStore = useLayoutStore();
        const wonderStore = useWonderStore();
        const data = {};
        lytStore.mapBuildings((building, buildingId) => {
            for (let i = 0; i < building.effects.count(); i++) {
                const effect = building.effects.getEffect(i);
                if (effect instanceof PassiveAura && effect.type === PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER) {
                    const amount = effect.getAmount(building.level || 1, building.era || playerEra);
                    if (amount) {
                        data[building.name] = (data[building.name] || 0) + amount;
                    }
                    break;
                }
            }
            return true;
        });
        wonderStore.mapWonders((wonder, config) => {
            for (let i = 0; i < wonder.effects.count(); i++) {
                if (config.active) {
                    const effect = wonder.effects.getEffect(i);
                    if (effect instanceof PassiveAura && effect.type === PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER) {
                        const amount = effect.getAmount(config.level, EraType.stoneAge);
                        if (amount) {
                            let am = amount;
                            applyWonderSynergies(wonder, config.level, i, function (effect, amount) {
                                if (effect.type === PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER) {
                                    am += amount;
                                }
                            });
                            data[wonder.name] = (data[wonder.name] || 0) + amount;
                        }
                    }
                }
            }
            return true;
        });
        const result = [];
        for (const i in data) {
            result.push({
                icon: 'Worker',
                description: `<b>${data[i]}</b> from <b>${i}</b>`,
            });
        }
        return result;
    }
}
export default WorkersCalculator;
